<script>

export default {
  props: ['item'],
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    address: function() {
      var result = "";
      if(this.item.StreetNumber) { result += ' '+this.item.StreetNumber; }
      if(this.item.StreetDirPrefix) { result += ' '+this.item.StreetDirPrefix; }
      if(this.item.StreetName) { result += ' '+this.item.StreetName; }
      if(this.item.StreetSuffix) { result += ' '+this.item.StreetSuffix; }
      if(this.item.StreetDirSuffix) { result += ' '+this.item.StreetDirSuffix; }
      if(this.item.UnitNumber) { result += ' '+this.item.UnitNumber; }
      this.item.Address = result.trim();
      return result.trim();
    },
  },
  created() {

  },
  methods: {
    submit_form() {
      if(this.loading == true) { console.log("disabled"); return; } this.loading = true;
      if(
        !this.item.PropertyType ||
        !this.item.PropertySubType ||
        !this.item.CountyOrParish ||
        !this.item.StreetNumber ||
        !this.item.StreetName ||
        !this.item.City ||
        !this.item.StateOrProvince ||
        !this.item.PostalCode
      ) {
        this.$noty.error("Please complete all of the required fields on this page before continuing.");
        this.loading = false; return;
      }

      this.$http.post('/listings/sellformvaluation', this.item).then(res => {
        console.log(res);
        if(res.data.output && res.data.output.mls && res.data.output.mls.id) {
          this.item.mls_id = res.data.output.mls.id;
          this.item.mls_title = res.data.output.mls.title;
          this.item.mls = res.data.output.mls;
        } else {
          this.$emit('setpage', 'noservice'); this.loading = false; return;
        }
        if(res.data.output) { for(var i in res.data.output) { this.item[i] = res.data.output[i]; } }
        if(res.data.output.listings_found > 0) {
          var n = new Noty({
            timeout: false,
            modal: true,
            type: 'alert', // alert, success, warning, error, info
            layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
            closeWith: ['button'], // click, button
            text: 'It appears you have previously listed this address. If you would like to change the details of your existing listing, please select "My account" and "My listings" on the top navigation bar to locate your existing listing. Otherwise, if you are sure you would like to submit this address again, please continue.',
            buttons: [
              Noty.button('I UNDERSTAND', 'btn btn-block btn-success', notyres => {
                this.$emit('setpage', 3);
                this.loading = false;
                n.close();
              }, {id: 'close_btn', 'data-status': 'ok'}),
            ]
          }).show().on('onClose', () => { this.loading = false; });
        } else {
          this.$emit('setpage', 3);
          this.loading = false;
        }
      }).catch(res => { this.loading = false; this.popupErrors(res); });
    }
  }
}
</script>

<template>

  <div class="_w-m-1000 mx-auto my-5">
    <form @submit.prevent="submit_form()">
      <div class="title text-center mb-5">
        <img :src="formatImage('/fm/revinre-nc/clip art/Real Estate Listings.png')" class="mb-5" data-aos="fade-zoom-in">
        <h3 class="mb-3" data-aos="fade-zoom-in">Property address</h3>
        <p class="text-muted" data-aos="fade-zoom-in">Enter your address below to get started. This will help us determine if your property is located in an area we currently service and will pull up your estimated home value.</p>
      </div>

      <div class="row">
        <div class="col-sm-4">
          <div class="form-group">
            <label for="input-PropertyType" v-tippy content="A list of types of properties such as Residential, Lease, Income, Land, Mobile, Commercial Sale, etc...">Property Type <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <select id="input-PropertyType" name="PropertyType" class="form-control" v-model="item.PropertyType" required>
              <option value="">-- Select --</option>
              <!-- <option value="Business Opportunity">Business Opportunity</option> -->
              <!-- <option value="Commercial Lease">Commercial Lease</option> -->
              <option value="Commercial Sale">Commercial Sale</option>
              <option value="Farm">Farm</option>
              <option value="Land">Land</option>
              <!-- <option value="Manufactured In Park">Manufactured In Park</option> -->
              <option value="Residential">Residential</option>
              <!-- <option value="Residential Income">Residential Income</option> -->
              <!-- <option value="Residential Lease">Residential Lease</option> -->
            </select>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="input-PropertySubType" v-tippy content="A list of types of residential and residential lease properties, i.e. SFR, Condo, etc. Or a list of Sub Types for Mobile, such as Expando, Manufactured, Modular, etc.">Property Sub Type <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <select id="input-PropertySubType" name="PropertySubType" class="form-control" v-model="item.PropertySubType" required>
              <option value="">-- Select --</option>
              <option value="Apartment">Apartment</option>
              <!-- <option value="Boat Slip">Boat Slip</option> -->
              <option value="Cabin">Cabin</option>
              <option value="Condominium">Condominium</option>
              <!-- <option value="Deeded Parking">Deeded Parking</option> -->
              <option value="Duplex">Duplex</option>
              <option value="Farm">Farm</option>
              <option value="Manufactured Home">Manufactured Home</option>
              <option value="Manufactured On Land">Manufactured On Land</option>
              <option value="Mobile Home">Mobile Home</option>
              <!-- <option value="Own Your Own">Own Your Own</option> -->
              <option value="Quadruplex">Quadruplex</option>
              <option value="Ranch">Ranch</option>
              <option value="Single Family Residence">Single Family Residence</option>
              <!-- <option value="Stock Cooperative">Stock Cooperative</option> -->
              <!-- <option value="Timeshare">Timeshare</option> -->
              <option value="Townhouse">Townhouse</option>
              <option value="Triplex">Triplex</option>
              <option value="Agriculture">Agriculture</option>
              <option value="Business">Business</option>
              <!-- <option value="Hotel-Motel">Hotel-Motel</option> -->
              <option value="Industrial">Industrial</option>
              <!-- <option value="Mixed Use">Mixed Use</option> -->
              <option value="Multi Family">Multi Family</option>
              <option value="Office">Office</option>
              <option value="Retail">Retail</option>
              <option value="Unimproved Land">Unimproved Land</option>
              <option value="Warehouse">Warehouse</option>
            </select>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="input-CountyOrParish" v-tippy content="The County, Parish or other regional authority">County/Parish <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <input id="input-CountyOrParish" name="CountyOrParish" type="text" class="form-control" v-model="item.CountyOrParish" required>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="input-StreetNumber" v-tippy content="The street number portion of a listed property's street address. In some areas the street number may contain non-numeric characters. This field can also contain extensions and modifiers to the street number, such as '1/2' or '-B'. This street number field should not include Prefixes, Direction or Suffixes.">Street number <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <input id="input-StreetNumber" name="StreetNumber" type="text" class="form-control" v-model="item.StreetNumber" required>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="input-StreetDirPrefix" v-tippy content="The direction indicator that precedes the listed property's street name.">Street direction</label>
            <select id="input-StreetDirPrefix" name="StreetDirPrefix" class="form-control" v-model="item.StreetDirPrefix">
              <option value="">-- Select --</option>
              <option value="E">E</option>
              <option value="N">N</option>
              <option value="NE">NE</option>
              <option value="NW">NW</option>
              <option value="S">S</option>
              <option value="SE">SE</option>
              <option value="SW">SW</option>
              <option value="W">W</option>
              <option value="-">-</option>
            </select>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="input-StreetName" v-tippy content="The street name portion of a listed property's street address.">Street name <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <input id="input-StreetName" name="StreetName" type="text" class="form-control" v-model="item.StreetName" required>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="input-StreetSuffix" v-tippy content="The suffix portion of a listed property's street address.">Street suffix</label>
            <input id="input-StreetSuffix" name="StreetSuffix" type="text" class="form-control" v-model="item.StreetSuffix">
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="input-StreetDirSuffix" v-tippy content="The direction indicator that follows a listed property's street address.">Street direction suffix</label>
            <select id="input-StreetDirSuffix" name="StreetDirSuffix" class="form-control" v-model="item.StreetDirSuffix">
              <option value="">-- Select --</option>
              <option value="E">E</option>
              <option value="N">N</option>
              <option value="NE">NE</option>
              <option value="NW">NW</option>
              <option value="S">S</option>
              <option value="SE">SE</option>
              <option value="SW">SW</option>
              <option value="W">W</option>
              <option value="-">-</option>
            </select>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="input-UnitNumber" v-tippy content="Text field containing the number or portion of a larger building or complex. Unit Number should appear following the street suffix or, if it exists, the street suffix direction, in the street address. Examples are: 'APT G', '55', etc.">Unit/Suite Number</label>
            <input id="input-UnitNumber" name="UnitNumber" type="text" class="form-control" v-model="item.UnitNumber">
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="input-City" v-tippy content="The city in listing address.">City <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <input id="input-City" name="City" type="text" class="form-control" v-model="item.City" required>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="input-StateOrProvince" v-tippy content="Text field containing the accepted postal abbreviation for the state or province.">State <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <select id="input-StateOrProvince" name="StateOrProvince" class="form-control" v-model="item.StateOrProvince" required>
              <option value="">-- Select --</option>
              <option value="AL">Alabama</option>
              <option value="AK">Alaska</option>
              <option value="AZ">Arizona</option>
              <option value="AR">Arkansas</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DE">Delaware</option>
              <option value="DC">District Of Columbia</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="IA">Iowa</option>
              <option value="KS">Kansas</option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana</option>
              <option value="ME">Maine</option>
              <option value="MD">Maryland</option>
              <option value="MA">Massachusetts</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota</option>
              <option value="MS">Mississippi</option>
              <option value="MO">Missouri</option>
              <option value="MT">Montana</option>
              <option value="NE">Nebraska</option>
              <option value="NV">Nevada</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NY">New York</option>
              <option value="NC">North Carolina</option>
              <option value="ND">North Dakota</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon</option>
              <option value="PA">Pennsylvania</option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina</option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee</option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VT">Vermont</option>
              <option value="VA">Virginia</option>
              <option value="WA">Washington</option>
              <option value="WV">West Virginia</option>
              <option value="WI">Wisconsin</option>
              <option value="WY">Wyoming</option>
            </select>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="input-PostalCode" v-tippy content="The postal code portion of a street or mailing address.">Zip code <span class="text-danger" v-tippy content="This field is required.">*</span></label>
            <input id="input-PostalCode" name="PostalCode" type="text" class="form-control" v-model="item.PostalCode" required>
            <small class="text-muted"></small>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="form-group">
            <label for="input-Address" v-tippy content="Output of the complete address entered above.">Full address output</label>
            <div class="py-2 px-3 border rounded bg-light">{{address}} {{item.City}} {{item.StateOrProvince}} {{item.PostalCode}}</div>
            <small class="text-muted">Output of the complete address entered above.</small>
          </div>
        </div>
      </div>

      <div class="row py-5">
        <div class="col-6">
          <button type="button" class="btn btn-lg btn-success" @click="$emit('setpage', 1)" :disabled="loading"><Icon icon="ri:arrow-left-double-fill" /> Previous</button>
        </div>
        <div class="col-6 text-right">
          <button type="submit" class="btn btn-lg btn-success" :disabled="loading"><span class="spinner-border spinner-border-sm" v-show="loading"></span> Next <Icon icon="ri:arrow-right-double-fill" /></button>
        </div>
      </div>
    </form>
  </div>

</template>
